import fetch from 'isomorphic-fetch';
import { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import * as uuid from 'uuid';

import useEndpoints from './endpoints';
import { APIS, UPDATE_APIS, DELETE_APIS } from './helpers';
import { apiState, apiStatus } from '../atoms';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { loginRequest } from 'components/UI5/SSO/authConfig';
import { useHistory } from 'react-router-dom';
import { ms } from 'date-fns/locale';
// import GetBearerToken from 'components/UI5/SSO/ssoHelper';

// const _url = 'https://sap-dev.ineosautomotive.com';
const _url = process.env.REACT_APP_AGENT_PORTAL_API_URL + 'v1.0'; // icc URL
const _leadurl = process.env.REACT_APP_AGENT_PORTAL_API_URL + 'lead/v1.0'; // icc URL
const _leadMgturl =
  process.env.REACT_APP_AGENT_PORTAL_API_URL + 'saleslead/v1.0'; // icc URL
const _testDriveturl =
  process.env.REACT_APP_AGENT_PORTAL_API_URL + 'testdrive/v1.0'; // icc URL
const _caseurl = process.env.REACT_APP_AGENT_PORTAL_API_URL + 'case/v1.0'; // icc URL

const _status: Record<string, string> = {};
const _statusAlt: Record<string, string> = {};
const _noWait: Record<string, boolean> = {};

let data = {};

export const useApi = () => {
  // const [data, setData] = useRecoilState<any>(apiState);
  const [status, setStatus] = useRecoilState<any>(apiStatus);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<any[]>();
  const { instance, accounts } = useMsal();
  // const { history } = useHistory();
  // const getBearerToken = GetBearerToken(instance, accounts);
  const getBearerToken = useCallback(async () => {
    let token = '';
    // const r = await fetch('/.auth/me');
    // if (r) {
    //   const reader = r.body.getReader();
    //   console.log('TEST :::');
    //   reader.read().then(({ done, value }) => {
    //     console.log('TEST ****', btoa(value));
    //   });
    // }
    if (!accounts?.length) {
      instance.initialize();
      console.log('NO ACCOUNTS');
      // history.push('/login');
      if (!window.location.pathname?.includes('login'))
        window.location.href = '/login';
      return '';
    }
    let response = await instance.acquireTokenSilent({
      ...(loginRequest as any),
      account: accounts[0] as any,
    });
    // .then((response) => {
    //   console.log('Response after login');
    //   console.log(response);
    //   token = response.accessToken;
    //   // callMsGraph(response.accessToken).then(response => setGraphData(response));
    // });
    token = response?.accessToken;
    if (!token)
      if (!window.location.pathname?.includes('login'))
        window.location.href = '/login';

    return token;
    // const fName = localStorage.getItem('SSOBearerToken');

    // if (fName) document.cookie = 'SSOBearerToken=' + fName;

    // return fName || null;
  }, [accounts, instance]);

  const parseError = (error: any) => {
    if (
      error.message?.includes(
        'Application requested a user session which does not exist'
      )
    ) {
      if (!window.location.pathname?.includes('login'))
        window.location.href = '/login';
    }
  };

  const fetchApi = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean; cacheKey?: string }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    if (api === 'userDealersFetch') console.log(key);
    try {
      if (api.indexOf('notification') === -1) {
        _status[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_url}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (response.status === 400) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        const json = await response.json();
        return { status: 'error', message: 'API Error', data: json };
      }
      if (args?.asText) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) {
        const d = args?.cacheKey
          ? json[args?.cacheKey]
          : json?.d?.results || json?.d;
        console.log('cache :::', key, args?.cacheKey, d);
        data[key] = d;
      }
      // setData({ ...data, [key]: json?.d?.results || json?.d });
      if (api.indexOf('notification') === -1) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }
      // setStatus(status + 1);
      // console.log({ api, status });
      if (args?.cacheKey) return json[args?.cacheKey];
      return json?.d?.results || json?.d || json?.value || json?.error;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
    }
  };

  const fetchApiAlt = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean; cacheKey?: string }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    if (api === 'userDealersFetch') console.log(key);
    try {
      if (api.indexOf('notification') === -1) {
        _statusAlt[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_url}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (response.status === 400) {
        _statusAlt[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        const json = await response.json();
        return { status: 'error', message: 'API Error', data: json };
      }
      if (args?.asText) {
        _statusAlt[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) {
        const d = args?.cacheKey
          ? json[args?.cacheKey]
          : json?.d?.results || json?.d;
        console.log('cache :::', key, args?.cacheKey, d);
        data[key] = d;
      }
      // setData({ ...data, [key]: json?.d?.results || json?.d });
      if (api.indexOf('notification') === -1) {
        _statusAlt[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }
      // setStatus(status + 1);
      // console.log({ api, status });
      if (args?.cacheKey) return json[args?.cacheKey];
      return json?.d?.results || json?.d || json?.value || json?.error;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _statusAlt[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
    }
  };

  const fetchNoCache = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean; cacheKey?: string }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    if (api === 'userDealersFetch') console.log(key);
    try {
      if (api.indexOf('notification') === -1) {
        _status[key] = 'loading';
      }
      const response = await fetch(`${_url}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (args?.asText) {
        _status[key] = 'done';
        return response.text();
      }
      const json = await response.json();
      // setStatus(status + 1);
      // console.log({ api, status });
      if (args?.cacheKey) return json[args?.cacheKey];
      return json?.d?.results || json?.d || json?.value || json?.error;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const updateApi = async (
    api: keyof UPDATE_APIS,
    path: string,
    token: string,
    options: any = { method: 'PATCH' }
  ) => {
    try {
      if (api.indexOf('notification') === -1)
        setStatus({ ...status, [api]: 'loading' });
      const response = await fetch(`${_url}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          // 'x-csrf-token': token,
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }

      if (response.status === 400) {
        setStatus({ ...status, [api]: 'done' });
        return await response.json();
      }
      if (api.indexOf('notification') === -1)
        setStatus({ ...status, [api]: 'done' });
      if (api.includes('create')) {
        const json = await response.json();
        return json?.d?.results || json?.d || json?.value;
      }
      if (api === 'notificationAction') {
        const json = await response.json();
        return json;
      } else {
        return response;
      }
    } catch (e: any) {
      console.log(`API:${api}:::::`, e);
      setStatus({ ...status, [api]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const deleteApi = async (
    api: keyof DELETE_APIS,
    path: string,
    token: string,
    options: any = { method: 'DELETE' }
  ) => {
    try {
      setStatus({ ...status, [api]: 'loading' });
      const response = await fetch(`${_url}${path}`, {
        ...options,
        headers: {
          // 'x-csrf-token': token,
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }

      setStatus({ ...status, [api]: 'done' });
      return response;
    } catch (e: any) {
      console.error(`API:${api}:::::`, e);
      setStatus({ ...status, [api]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const fetchLeadApi = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    try {
      if (api.indexOf('notification') === -1) {
        _status[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_leadurl}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (args?.asText) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      // console.log('MAP :::', json);
      if (!args?.noCache) data[key] = json?.d?.results || json?.d || json;
      // setData({ ...data, [key]: json?.d?.results || json?.d });
      if (api.indexOf('notification') === -1) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }
      // setStatus(status + 1);
      // console.log({ api, status });
      return json?.d?.results || json?.d || json?.value || json?.error || json;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const fetchLeadMgtApi = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    // console.log('fetch key ::::', key);
    try {
      if (api.indexOf('notification') === -1) {
        // _status[key] = noWait ? 'nowait' : 'loading';
        _status[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_leadMgturl}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });

      if (api.indexOf('notification') === -1) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }

      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (args?.asText) {
        // _status[key] = 'done';
        // setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) data[key] = json?.leads || json?.d || json;
      // setStatus(status + 1);
      // console.log({ api, status });
      return json?.leads || json?.d || json?.value || json?.error || json;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const fetchLeadMgtApiAlt = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    // console.log('fetch key ::::', key);
    try {
      if (api.indexOf('notification') === -1) {
        // _status[key] = noWait ? 'nowait' : 'loading';
        _statusAlt[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_leadMgturl}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });

      if (api.indexOf('notification') === -1) {
        _statusAlt[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }

      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (args?.asText) {
        // _status[key] = 'done';
        // setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) data[key] = json?.leads || json?.d || json;
      // setStatus(status + 1);
      // console.log({ api, status });
      return json?.leads || json?.d || json?.value || json?.error || json;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _statusAlt[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const fetchTestDriveApi = async (
    api: keyof APIS,
    path: string,
    options: any = { method: 'GET' },
    args: { noCache?: boolean; asText?: boolean }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    // console.log('fetch key ::::', key);
    try {
      if (api.indexOf('notification') === -1) {
        _status[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_testDriveturl}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
          correlationId: uuid.v4(),
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (response.status === 400) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return { status: 'error', message: 'API Error' };
      }
      if (args?.asText) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) data[key] = json?.leads || json?.d || json;
      if (api.indexOf('notification') === -1) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }
      // setStatus(status + 1);
      // console.log({ api, status });
      return json?.leads || json?.d || json?.value || json?.error || json;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
    }
  };

  const updateTestDriveApi = async (
    api: keyof UPDATE_APIS,
    path: string,
    options: any = { method: 'PATCH' },
    body: any,
    msgType: string,
    entity: { name: string; id: any }[],
    userId: string,
    _isSlotTimeChanged?: boolean
  ) => {
    try {
      if (api.indexOf('notification') === -1)
        setStatus({ ...status, [api]: 'loading' });
      const corrid = uuid.v4();
      const response = await fetch(
        `${_testDriveturl}${path}${
          entity?.length
            ? '?' + entity?.map((e) => `${e.name}=${e.id}`).join('&')
            : ''
        }`,
        {
          ...options,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            // 'x-csrf-token': token,
            'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
            Authorization: `Bearer ${await getBearerToken()}`,
            correlationId: corrid,
          },
          body: body
            ? JSON.stringify({
                msgHeader: {
                  correlationId: corrid,
                  sourceSysId: 'pp',
                  msgType: msgType, // 'create-model',
                  requestedBy: userId,
                  isSlotTimeChanged: _isSlotTimeChanged,
                },
                msgBody: body,
              })
            : null,
        }
      );
      console.log('updateTestDriveApi', api, path, response?.status);
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }

      if (response.status === 400 || response.status === 500) {
        setStatus({ ...status, [api]: 'done' });
        const data = await response.json();
        return { ...data, status: 'error' };
      }
      if (api.indexOf('notification') === -1)
        setStatus({ ...status, [api]: 'done' });
      if (api.includes('create')) {
        const json = await response.json();
        return json?.d?.results || json?.d || json?.value;
      }
      if (api === 'notificationAction') {
        const json = await response.json();
        return json;
      } else {
        const data = await response.json();
        return data;
      }
    } catch (e: any) {
      console.log(`API:${api}:::::`, e);
      setStatus({ ...status, [api]: `error::${e.toString()}` });
      parseError(e);
      return { status: 'error', message: e.message };
    }
  };

  const fetchCaseApi = async (
    api: keyof APIS,
    path?: string,
    options: any = { method: 'GET' },
    args?: { noCache?: boolean; asText?: boolean; cacheKey?: string }
  ) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    try {
      if (api.indexOf('notification') === -1) {
        _status[key] = 'loading';
        setStatus({ ...status, [key]: 'loading' });
      }
      const response = await fetch(`${_caseurl}${path}`, {
        ...options,
        headers: {
          Accept: 'application/json',
          'subscription-key': process.env.REACT_APP_AGENT_PORTAL_API_SUB_KEY,
          Authorization: `Bearer ${await getBearerToken()}`,
        },
      });
      if (response.status === 401) {
        // TODO: unauthed logic - move auth to recoil state
        if (!window.location.pathname?.includes('login'))
          window.location.href = '/login';
      }
      if (args?.asText) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
        return response.text();
      }
      const json = await response.json();
      if (!args?.noCache) {
        const d = args?.cacheKey
          ? json[args?.cacheKey]
          : json?.d?.results || json?.d;
        console.log('cache case :::', key, args?.cacheKey, d);
        data[key] = d;
      }
      // !args?.noCache &&
      //   setData({ ...data, [key]: json?.d?.results || json?.d });
      if (api.indexOf('notification') === -1) {
        _status[key] = 'done';
        setStatus({ ...status, [key]: 'done' });
      }
      // setStatus(status + 1);
      // console.log({ api, status });
      if (args?.cacheKey) return json[args?.cacheKey];
      return json;
    } catch (e: any) {
      console.error(`API:${key}:::::`, e);
      _status[key] = `error::${e.toString()}`;
      setStatus({ ...status, [key]: `error::${e.toString()}` });
      parseError(e);
    }
  };

  const { _apis, _updateAPIs, _deleteAPIs } = useEndpoints({
    fetchApi,
    fetchApiAlt,
    updateApi,
    deleteApi,
    fetchLeadApi,
    fetchLeadMgtApi,
    fetchLeadMgtApiAlt,
    fetchCaseApi,
    fetchNoCache,
    fetchTestDriveApi,
    updateTestDriveApi,
  });

  useEffect(() => {
    const f = async () => {
      const r1 = Object.values(_status).some(
        (x) => x === 'loading' || x === 'nowait'
      );
      setIsLoading(r1);
      const r2 = Object.values(_status).filter((x: any) =>
        x?.includes('error::')
      );
      setIsError(r2);
      if (r2) {
        // await getBearerToken();
        // instance?.acquireTokenSilent({
        //   ...(loginRequest as any),
        //   account: accounts[0] as any,
        // });
        // instance.logoutRedirect({onRedirectNavigate: });
        // instance.logout();
        // instance.initialize();
      }
    };
    setTimeout(f, 10);
  }, [status]);

  const callUpdate = async (api: keyof UPDATE_APIS, data: any) => {
    const response = await _updateAPIs[api](data);
    return response;
  };

  const callDelete = async (
    api: keyof DELETE_APIS,
    token: any,
    service: string,
    entity: string
  ) => {
    const response = await _deleteAPIs[api](service, entity);
    return response;
  };

  const call = async (api: keyof APIS, args?: any) => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    if (api === 'userDealersFetch') console.log(key);
    if (['loading', 'nowait'].includes(_status[key])) return [];
    if (['loading', 'nowait'].includes(_statusAlt[key])) return [];
    const response = await _apis[api](args);
    return response;
  };

  const get = async (api: keyof APIS, args?: any): Promise<any> => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    console.log('get ::::', key, data?.[key]);
    if (!!data?.[key]) return data?.[key];
    if (['loading', 'nowait'].includes(_status[key])) return [];
    if (['loading', 'nowait'].includes(_statusAlt[key])) return [];
    const response = await call(api, args);
    return response;
  };

  const cached = async (api: keyof APIS, args?: any): Promise<any> => {
    const key = `${api}:${
      typeof args === 'string' ? args : args ? JSON.stringify(args) : ''
    }`;
    // console.log('cache key ::::', key);
    if (data?.[key]) return data?.[key];
    return undefined;
  };

  return {
    call,
    get,
    cached,
    fetchApi,
    fetchLeadMgtApi,
    updateTestDriveApi,
    deleteApi,
    updateApi,
    callDelete,
    callUpdate,
    _status,
    isLoading,
    isError,
    getBearerToken,
  };
};
